import * as React from 'react';

function SvgSlackMark(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.404 29.276a4.212 4.212 0 01-4.202 4.202A4.212 4.212 0 014 29.276a4.212 4.212 0 014.202-4.202h4.202v4.202zM14.521 29.276a4.212 4.212 0 014.202-4.202 4.212 4.212 0 014.202 4.202v10.521a4.212 4.212 0 01-4.202 4.202 4.212 4.212 0 01-4.202-4.202v-10.52z"
        fill="#E01E5A"
      />
      <path
        d="M18.723 12.404a4.212 4.212 0 01-4.202-4.202A4.212 4.212 0 0118.723 4a4.212 4.212 0 014.202 4.202v4.202h-4.202zM18.723 14.521a4.212 4.212 0 014.202 4.202 4.212 4.212 0 01-4.202 4.202H8.202A4.212 4.212 0 014 18.723a4.212 4.212 0 014.202-4.201h10.52z"
        fill="#36C5F0"
      />
      <path
        d="M35.596 18.723a4.212 4.212 0 014.201-4.201A4.212 4.212 0 0144 18.723a4.212 4.212 0 01-4.202 4.202h-4.201v-4.202zM33.478 18.723a4.212 4.212 0 01-4.202 4.202 4.212 4.212 0 01-4.201-4.202V8.202A4.212 4.212 0 0129.276 4a4.212 4.212 0 014.202 4.202v10.52z"
        fill="#2EB67D"
      />
      <path
        d="M29.276 35.596a4.212 4.212 0 014.202 4.202 4.212 4.212 0 01-4.202 4.201 4.212 4.212 0 01-4.201-4.201v-4.202h4.201zM29.276 33.48a4.212 4.212 0 01-4.201-4.202 4.212 4.212 0 014.201-4.202h10.521A4.212 4.212 0 0144 29.278a4.212 4.212 0 01-4.202 4.202h-10.52z"
        fill="#ECB22E"
      />
    </svg>
  );
}

export default SvgSlackMark;
